import * as React from 'react';

import LoyaltyConnect from '../../../../../../Loyalty/components/LoyaltyStub/LoyaltyConnect/LoyaltyConnect';
import { TravellerFieldEnum, useGetAccountInfoQuery } from '@websky/graphql';
import { getUserValue } from '../../../../../../utils';
import { useConfigRedirects } from '../../../../../../hooks';
import { UserInfo } from '../../../../../../Account/types';

interface Props {
	setLoyalty: (cardNumber: string, logged?: boolean) => void;
	children: (requestLoyaltyCard: () => void) => React.ReactNode;
}

const LoyaltyCard: React.FC<Props> = props => {
	const { onGoToAccountSettings } = useConfigRedirects();

	const [isLoyaltyConnectOpen, setLoyaltyConnectOpen] = React.useState(false);

	const { data, refetch } = useGetAccountInfoQuery({ fetchPolicy: 'no-cache' });

	const userInfo: UserInfo = React.useMemo(() => {
		if (!data?.CurrentUser || !data.CurrentUser?.userProfile) {
			return {
				lastName: '',
				firstName: '',
				email: ''
			};
		}

		return {
			lastName: getUserValue(data.CurrentUser.userProfile, TravellerFieldEnum.LastName),
			firstName: getUserValue(data.CurrentUser.userProfile, TravellerFieldEnum.FirstName),
			email: getUserValue(data.CurrentUser.userProfile, TravellerFieldEnum.Email)
		};
	}, [data?.CurrentUser]);

	const onLoyaltyConnectCloseHandler = () => {
		props.setLoyalty('');
		setLoyaltyConnectOpen(false);
	};

	const onLoyaltyConnectCardSavedHandler = async () => {
		try {
			const { data } = await refetch();

			if (data?.CurrentUser?.userFfpInfo) {
				props.setLoyalty(data.CurrentUser.userFfpInfo.cardNumber, true);
			}
		} catch (e) {
			console.log(e);
		} finally {
			setLoyaltyConnectOpen(false);
		}
	};

	const requestLoyaltyCard = () => {
		if (data?.CurrentUser?.userFfpInfo && !data?.CurrentUser?.isFfpAuthorizationNeeded) {
			props.setLoyalty(data.CurrentUser.userFfpInfo.cardNumber);
		} else {
			setLoyaltyConnectOpen(true);
		}
	};

	return (
		<>
			{props.children(requestLoyaltyCard)}

			<LoyaltyConnect
				userInfo={userInfo}
				isOpen={isLoyaltyConnectOpen}
				onLoyaltyCardSaved={onLoyaltyConnectCardSavedHandler}
				onClose={onLoyaltyConnectCloseHandler}
				onGoToSettings={onGoToAccountSettings}
				showRegisterAction={!!data?.CurrentUser}
				authType="authenticate"
			/>
		</>
	);
};

export default LoyaltyCard;
